import { render } from "./OrderRecordList.vue?vue&type=template&id=f8ee2d32&scoped=true"
import script from "./OrderRecordList.vue?vue&type=script&lang=js"
export * from "./OrderRecordList.vue?vue&type=script&lang=js"

import "./OrderRecordList.vue?vue&type=style&index=0&id=f8ee2d32&lang=scss"
import "./OrderRecordList.vue?vue&type=style&index=1&id=f8ee2d32&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ee2d32"]])

export default __exports__